export default function Loader() {
    return <div className="horizontal-bar-wrap">
        <div className="bar1 bar"></div>
    </div>;
}

export const LinearLoader: React.FC<{ dots?: number }> = ({ dots = 5 }) => {
    return (
        <div className="linear-loader">
            {Array.from({ length: dots }).map((_, index) => (
                <div
                    key={index}
                    style={
                        { "--index": index } as React.CSSProperties /* Explicit typing */
                    }
                ></div>
            ))}
        </div>
    );
};
